import React from "react";
import { Box, Typography, Chip } from "@mui/material";
import { BaseActionRendererProps, TodoData, getActionData } from "./BaseActionRenderer";

export const TodoActionRenderer: React.FC<BaseActionRendererProps> = ({ actionData }) => {
  const todoData = getActionData(actionData) as TodoData;

  const title = todoData.title || actionData.title || "New Todo";
  const description = todoData.description;
  const priority = todoData.priority;
  const deadline = todoData.deadline;

  return (
    <Box sx={{ mb: 2 }}>
      <Typography variant="body1" sx={{ fontWeight: 500 }} gutterBottom>
        Todo: {title}
      </Typography>

      {description && (
        <Typography variant="body2" sx={{ mb: 1, whiteSpace: "pre-line" }}>
          {description}
        </Typography>
      )}

      {priority && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Priority:
          </Typography>
          <Chip label={priority} size="small" color={priority === "high" ? "error" : priority === "medium" ? "warning" : "default"} variant="outlined" />
        </Box>
      )}

      {deadline && (
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Deadline:
          </Typography>
          <Typography variant="body2">{new Date(deadline).toLocaleDateString()}</Typography>
        </Box>
      )}

      {actionData.reason && (
        <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
          Reason: {actionData.reason}
        </Typography>
      )}
    </Box>
  );
};
